import LoginFormContainer from './LoginFormContainer.vue';

export default LoginFormContainer;
